/* global $ */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */
/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalConsultaSinFinalizar.css';
import * as telemedicinaAction from '../../../actions/telemedicinaActions';

class ModalConsultaSinFinalizar extends React.Component {
  constructor(props) {
    super(props);
    this.hideModalVideoLlamada = this.hideModalVideoLlamada.bind(this);
  }

  hideModalVideoLlamada() {
    if(this.props.llamadaIniciada){
      document
      .getElementById('localView')
      .srcObject.getTracks()
      .forEach(track => track.stop());
      $('localView').srcObject = null;
    }
    
    $('#estudiosIcon').popover('hide');
    $('#modalVideoLlamada').fadeOut(200);

    /* const hoy = new Date();
    hoy.setDate(hoy.getDate());
    let dd = hoy.getDate();
    let mm = hoy.getMonth() + 1;
    const yyyy = hoy.getFullYear();

    if (dd < 10) {
      dd = `0${dd}`;
    }

    if (mm < 10) {
      mm = `0${mm}`;
    }
    const fecha = yyyy + mm + dd;

    const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    const datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
    const token = datos.token;
    const contra = datos.modelEspecifico.contra;
    const inte = datosInteSelected.inte;
    const prepaga = datosInteSelected.prepaga;

    const dataCalif = {
      token,
      prepaga,
      contra,
      inte,
      fecha,
    };

    fetch(`${generateAbsoluteUrl()}/api/telemedicinaConsumos`, {
      method: 'POST',
      body: JSON.stringify(dataCalif),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    })
      .then(res => res.json())
      .then(response => {
        if (response.length > 0) {
          this.props.guardarTransaccionConsumo(response[0].transaccion);
          $('#modalCalificacion').modal();
        } else {
          $('#modalFinalizado').modal({ backdrop: 'static', keyboard: false });
        }
      }); */
    // this.props.cleanLlamada();
    // this.props.disconnect();
    $('#modalFinalizado').modal({ backdrop: 'static', keyboard: false });
  }
  render() {
    return (
      <div className="modal fade" id="modalConsultaSinFinalizar">
        <div className="modal-dialog">
          <div className={`${s.modalContent} modal-content`}>
            <div className="modal-header">
              <h5 className="modal-title">¿Salir de E-Consulta?</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className={`${s.modalBody} modal-body`}>
              <div>Aún no finalizaste la E-Consulta.</div>
              <div className="font-weight-bold">
                ¿Querés salir sin terminarla?
              </div>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <button
                data-dismiss="modal"
                className={`${s.boton_blanco} btn btn-default`}
              >
                Continuar
              </button>
              <button
                data-dismiss="modal"
                className={`${s.boton_rojo} btn btn-danger`}
                onClick={() => {
                  // this.props.disconnect();
                  this.hideModalVideoLlamada();
                }}
              >
                Si, Salir
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, telemedicinaAction)(
  withStyles(s)(ModalConsultaSinFinalizar),
);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalConsultaSinFinalizar/ModalConsultaSinFinalizar.js